import { render, staticRenderFns } from "./EnableTotp.vue?vue&type=template&id=e130b0a8&scoped=true"
import script from "./EnableTotp.vue?vue&type=script&lang=ts"
export * from "./EnableTotp.vue?vue&type=script&lang=ts"
import style0 from "./EnableTotp.vue?vue&type=style&index=0&id=e130b0a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e130b0a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e130b0a8')) {
      api.createRecord('e130b0a8', component.options)
    } else {
      api.reload('e130b0a8', component.options)
    }
    module.hot.accept("./EnableTotp.vue?vue&type=template&id=e130b0a8&scoped=true", function () {
      api.rerender('e130b0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/EnableTotp.vue"
export default component.exports